module.exports = __webpack_public_path__ + "static/media/intro.fc7e5196.mp3";